// useLanguage.js - Hook personalizado para manejo de idiomas
import React, { useState, createContext, useContext, useEffect } from 'react';
import { appData, defaultLanguage } from '../data/appData';

// Crear contexto para el idioma
const LanguageContext = createContext();

// Provider del contexto
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Intentar obtener el idioma guardado en localStorage
    return localStorage.getItem('preferredLanguage') || defaultLanguage;
  });

  const changeLanguage = (language) => {
    if (appData.languages[language]) {
      setCurrentLanguage(language);
      localStorage.setItem('preferredLanguage', language);
    }
  };

  // Función para obtener texto traducido
  const getText = (path) => {
    const keys = path.split('.');
    let result = appData.languages[currentLanguage];
    
    for (const key of keys) {
      if (result && result[key]) {
        result = result[key];
      } else {
        // Fallback al idioma por defecto si no se encuentra la traducción
        result = appData.languages[defaultLanguage];
        for (const fallbackKey of keys) {
          if (result && result[fallbackKey]) {
            result = result[fallbackKey];
          } else {
            console.warn(`Missing translation: ${path}`);
            return `Missing translation: ${path}`;
          }
        }
        break;
      }
    }
    
    return result || `Missing translation: ${path}`;
  };

  // Función para obtener datos que pueden estar en múltiples idiomas
  const getLocalizedData = (data, key) => {
    if (data && typeof data === 'object' && data[currentLanguage]) {
      return data[currentLanguage];
    }
    return data;
  };

  const value = {
    currentLanguage,
    changeLanguage,
    getText,
    getLocalizedData,
    isSpanish: currentLanguage === 'es',
    isEnglish: currentLanguage === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook para usar el contexto de idioma
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default useLanguage;
